import { Modal } from "antd";
import { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { RootState } from "../app/store";
import { RouteNames } from "../routes";
import { fetchPatients } from "../features/patient/patientsSlice";
import { PersonList } from "../components/PersonList";
import { Person } from "../model/person";
import { useTranslate } from "../i18n";
import { formatPhone } from "../utils/formatPhone";
import { getErrorMessage } from "../utils/getErrorMessage";

export const PatientsPage = () => {
    const dispatch = useAppDispatch();
    const t = useTranslate();
    const patients = useAppSelector((state: RootState) => state.patients.patients);
    const countries = useAppSelector((state: RootState) => state.country.countries);
    const status = useAppSelector((state: RootState) => state.patients.status);
    const error = useAppSelector((state: RootState) => state.patients.error);
    const navigate = useNavigate();
    const params = useParams();

    useEffect(() => {
        if (status === 'idle') {
            dispatch(fetchPatients())
        }

    });

    const [isErrorDismissed, setIsErrorDismissed] = useState(false);

    const isEditPage = params.patientId !== undefined;
    const onEditPatient = (id?: String) => {
        navigate(`/${RouteNames.patients}/${id}`);
    }

    const reloadPatients = () => {
        setIsErrorDismissed(false);
        dispatch(fetchPatients());
    }

    const onSearch = (query: string) => {
        dispatch(fetchPatients({ q: query }));
    }

    const handleOk = () => {
        setIsErrorDismissed(true);
        dispatch(fetchPatients());
    }

    const handleCancel = () => {
        setIsErrorDismissed(true);
    }

    if (isEditPage) {
        return <Outlet />;
    }

    const failed = status === "error" || status === "auth-error";
    const errorMessage = getErrorMessage(error, t);

    //todo implement server side paging and sorting
    return (<>
        <PersonList
            persons={patients?.map<Person>((patient) => {
                return {
                    id: patient.id ?? "",
                    firstName: patient.firstName ?? "",
                    lastName: patient.lastName ?? "",
                    phoneNumber: formatPhone(patient.userAccount?.mobileNumber, countries),
                    email: patient.userAccount?.emailAddress ?? ""
                };
            }) ?? []}
            title={t("nav.patients")}
            loading={status === "loading" || status === "idle"}
            onEditPerson={onEditPatient}
            onReload={reloadPatients}
            onSearch={onSearch}
        />
        <Modal
            title={errorMessage.title}
            visible={failed && !isErrorDismissed}
            onOk={handleOk}
            onCancel={handleCancel}
            okText={t("common.retry")}
        >
            <p>{errorMessage.details}</p>
        </Modal>
    </>);
}
